import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsStates from './enpoints'

const StatesService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsStates.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsStates.LOAD_BY_ID(id)),
  create: async (body) => POST(endpointsStates.CREATE, body),
  update: async ({ _id, body }) => PATCH(endpointsStates.LOAD_BY_ID(_id), body),
  remove: async (id) => DELETE(endpointsStates.LOAD_BY_ID(id)),
}

export default StatesService
